import { apiClient } from './apiClient';

export interface GeminiSettingsResponse {
  apiKey: string;
}

export const geminiSettingsService = {
  /**
   * Отримати збережений Gemini API ключ
   */
  async getApiKey(): Promise<string | null> {
    try {
      const response = await apiClient.get<GeminiSettingsResponse>('/settings/gemini');
      // Перевіряємо чи ключ не порожній
      return response?.apiKey?.trim() || null;
    } catch (error: any) {
      // Якщо ключ не знайдено (404), повертаємо null
      if (error?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  /**
   * Зберегти Gemini API ключ
   */
  async saveApiKey(apiKey: string): Promise<void> {
    await apiClient.post<{ apiKey: string }, void>('/settings/gemini', { apiKey });
  },

  /**
   * Видалити Gemini API ключ
   */
  async deleteApiKey(): Promise<void> {
    await apiClient.delete('/settings/gemini');
  }
};


